const padZeroes = (num) => num.toString().padStart(2, '0');

export default (seconds) => {
  if (!seconds) return '0:00:00';

  const secondsInt = Number(seconds);
  const h = Math.floor(secondsInt / 3600);
  const m = Math.floor(secondsInt / 60) % 60;
  const s = secondsInt % 60;

  return `${h}:${padZeroes(m)}:${padZeroes(s)}`;
};
